import { onboarding } from '@services';

interface ICreateMessage {
  fileId: string;
  studioId: string;
  groupId: string;
  threadId: string;
  text: string;
  triggeredByEmail?: string;
  triggeredBy?: string;
}

const createMessage = async (data: ICreateMessage): Promise<void> => {
  await onboarding.post(`/api/v1/chat/text`, data);
};

export { createMessage };
